import React from 'react';
import './App.css';
import {LayoutWrapper} from "./app/component/Layout/Layout";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import PDOilfield from "./app/component/PDOilfield/PDOilfield";
import Home from "./app/Home";
import {DataBase} from "./app/component/DataBase/DataBase";
import WellsGeothermal from "./app/component/WellsGeothermal/WellsGeothermal";
import WellsOilfield from "./app/component/WellsOilfield/WellsOilfield";
import {PDGeothermal} from "./app/component/PDGeothermal/PDGeothermal";
import {DemoBarNIR} from "./app/component/NIR/NIR";
import References from "./app/component/References/References";
import Contribute from "./app/component/Contribute/Contribute";
import { ROUTES } from './app/routes';
import HowItWorks from "./app/component/HowItWorks/HowItWorks";

function App() {
  return (
    <LayoutWrapper>
      <BrowserRouter>
        <Routes>
          <Route path={ROUTES.PDGEOTHERMAL} element={<PDGeothermal/>}/>
          <Route path={ROUTES.PDOILFIELD} element={<PDOilfield/>}/>
          <Route path={ROUTES.WELLSGEOTHERMAL} element={<WellsGeothermal/>}/>
          <Route path={ROUTES.WELLSOILFIELD} element={<WellsOilfield/>}/>
          <Route path={ROUTES.DATA} element={<DataBase/>}/>
          <Route path={ROUTES.REFERENCES} element={<References/>}/>
          {/*<Route path={ROUTES.OILFIELDDATA} element={<OilfieldData/>}/>*/}
          {/*<Route path={ROUTES.CONSUMPTIONDATA} element={<ConsumptionData/>}/>*/}
          <Route path={ROUTES.NIR} element={<DemoBarNIR/>}/>
          <Route path={ROUTES.CONTRIBUTE} element={<Contribute/>}/>
          <Route path="/how-it-works" element={<HowItWorks/>}/>
          <Route path="/" element={<Home/>}/>
          <Route path="*" element={<Home/>}/>
        </Routes>
      </BrowserRouter>
    </LayoutWrapper>
  );
}

export default App;
